export default {
  buttons: {
    confirm: 'Confirm',
  },
  toasts: {
    invalid_code: 'Invalid code. Please try again.',
  },
};
